import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-2a361b1e"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "microvideo-container"
};
var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "video-not-open-text"
  }, "摄像头未打开", -1);
});
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("video", {
    class: _normalizeClass(["video-monitor", {
      playing: _ctx.stream && !_ctx.microError
    }]),
    ref: "microVideoRef",
    controls: "",
    autoplay: "",
    playsinline: "",
    muted: ""
  }, null, 2)]);
}